import { render, staticRenderFns } from "./passengerInfo.vue?vue&type=template&id=6574c2f6&scoped=true&"
import script from "./passengerInfo.vue?vue&type=script&lang=js&"
export * from "./passengerInfo.vue?vue&type=script&lang=js&"
import style0 from "./passengerInfo.vue?vue&type=style&index=0&id=6574c2f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6574c2f6",
  null
  
)

export default component.exports